<div class="col-auto input-group">
  <ng-select
    class="width-100"
    [(ngModel)]="filterData.type"
    [clearable]="true"
    [multiple]="true"
    (ngModelChange)="this.emitChange()"
    placeholder="{{ 'Contract.type.placeholder' | translate }}"
  >
    <ng-option *ngFor="let type of ContractTypes" [value]="type">{{
      'Contract.typeEnum.' + type | translate
    }}</ng-option>
  </ng-select>
</div>
<div class="col input-group">
  <input
    id="search-admin-contract"
    type="text"
    [(ngModel)]="filterData.filter"
    (ngModelChange)="this.emitChange()"
    class="form-control"
    placeholder="{{ 'Contract.filter.placeholder' | translate }}"
  />
  <span class="input-group-prepend">
    <span class="input-group-text">
      <i class="icofont icofont-search"></i>
    </span>
  </span>
</div>
